import React from 'react';
import HostelSettings from './HostelSettings';

const AdminSettings = () => {
  return (
    <div data-testid="admin-settings">
      <HostelSettings />
    </div>
  );
};

export default AdminSettings;